<div class="panel panel-default resources-widget">
    <div class="panel-heading">
        Resources
        <span class="filter">
            <span class="dropdown">
                <span id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="filter-value">{{sort_type}}</span> <i class="feather chevron-down"></i>
                </span>
                <ul class="dropdown-menu" aria-labelledby="dLabel">
                    <li (click)="sort('order')"><a>Order</a></li>
                    <li (click)="sort('title')"><a>Title</a></li>
                    <li (click)="sort('type')"><a>Type</a></li>
                    <!-- <li><a><i class="feather file-text"></i> Documents</a></li>
                    <li><a><i class="feather film"></i> Videos</a></li> -->
                </ul>
            </span>
        </span>
        <button *ngIf="data.user_type == 1 && !preview" class="btn btn-success"
            (click)="openModal(resourcesModal)">Manage</button>
        <div class="panel-search" *ngIf="data.user_type == 2">
            <i class="feather search"></i> <input type="text" placeholder="Search" [(ngModel)]="search">
        </div>
    </div>
    <div class="panel-body scrollable">
        <!-- Placeholder -->
        <div class="text-center" *ngIf="company_resources.length == 0 && data.user_type == 1">
            <img src="assets/img/resources-illustration.svg" alt="Apps" width="130" style="margin-top:10px">
            <h4>Choose the Resources</h4>
            <p>Click on "Manage" to select the Resources to use with this client.</p>
        </div>

        <div class="text-center" *ngIf="company_resources.length == 0 && data.user_type == 2">
            <img src="assets/img/resources-illustration.svg" alt="Apps" width="130" style="margin-top:10px">
            <h4>Your Resources</h4>
            <p>Resources link have not been added for you.</p>
        </div>
        <!-- Placeholder -->

        <div class="">
            <div
                *ngFor="let resource of (company_resources | resourceSearch:search); let i = index; trackBy: trackById">
                <app-resources-item [resource]="resource" [link]="true"></app-resources-item>
            </div>
        </div>
    </div>
</div>